import { render } from "./dashboard-container.vue?vue&type=template&id=bfaae856"
import script from "./dashboard-container.vue?vue&type=script&lang=js"
export * from "./dashboard-container.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__